export const ADMIN_API_URL = `/admin/`;
